import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccountContent } from '../../selectors/uiSelector';
import { DASHPASS_STATUS } from '../../types/dashpass';
import DashPassSubscribed from './DashPassSubscribed';
import DashPassUnSubscribed from './DashPassUnSubscribed';
import { useTeamAccountConfigurationContext } from '../TeamAccountPlanDetails/TeamAccountConfigurationContext';
import { TeamAccountPlan } from '../../types/GloblalTypes';
import SelfServeDashPassPage from './SelfServeDashPassPage';
export var DashPassContainer = function () {
    var _a;
    var selectedTeamAccount = useSelector(getSelectedTeamAccountContent);
    var hasDashPassForSelectedAccount = ((_a = selectedTeamAccount === null || selectedTeamAccount === void 0 ? void 0 : selectedTeamAccount.dashPass) === null || _a === void 0 ? void 0 : _a.status) ===
        DASHPASS_STATUS.TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE;
    var teamAccountPlan = useTeamAccountConfigurationContext().teamAccountPlan;
    if (teamAccountPlan === TeamAccountPlan.WORK_PLAN_SELF_SERVE_FREE) {
        return React.createElement(SelfServeDashPassPage, null);
    }
    return hasDashPassForSelectedAccount ? (React.createElement(DashPassSubscribed, null)) : (React.createElement(DashPassUnSubscribed, null));
};
export default DashPassContainer;
